import { Spinner } from '@ami/react/core';
import { CustomerApprovalOrderLookupViewModel, customerApprovalStatus, ordersLookupServices } from '@ami/react/shared';
import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CustomerApprovalContactInfo from '../../components/approvals/CustomerApprovalContactInfo';
import CustomerApprovalList from '../../components/approvals/CustomerApprovalList';
import CustomerApprovalWithoutDocuments from '../../components/approvals/CustomerApprovalWithoutDocuments';
import customerApprovalLookupServices from '../../services/customerApprovalLookupServices';
import Menu from '../../components/Menu';
// import './CustomerApprovals.scss';

class CustomerApprovalPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      entity: new CustomerApprovalOrderLookupViewModel(),
      items: [],
      fullName: '',
      loading: false,
      countWaitingForApproval: 0,
      countApproved: 0,
      countRejected: 0,
    };
  }

  async componentDidMount() {
    document.body.style.backgroundColor = '#252830';
    if (this.props.match.params.id) {
      await this.loadEntity();
    }
  }

  loadEntity = async () => {
    if (!this.state.loading) {
      this.setState({ loading: true });
    }

    await ordersLookupServices
      .getOrderCustomerApproval(this.props.match.params.id)
      .then((entity) => {
        this.setState({ entity: entity });
        const countWaitingForApproval = entity.result.documents.filter(
          function (item) {
            return item.status === customerApprovalStatus.waitingForApproval.id;
          }
        ).length;

        const countApproved = entity.result.documents.filter(function (item) {
          return item.status === customerApprovalStatus.approved.id;
        }).length;

        const countRejected = entity.result.documents.filter(function (item) {
          return item.status === customerApprovalStatus.rejected.id;
        }).length;
        this.setState({ countWaitingForApproval: countWaitingForApproval });
        this.setState({ countApproved: countApproved });
        this.setState({ countRejected: countRejected });
        if (countWaitingForApproval === 0 && entity.isValid) {
          this.searchCustomerApproval();
        }
      })
      .finally(() => this.setState({ loading: false }));
  };

  searchCustomerApproval = async () => {
    this.setState({
      items: await customerApprovalLookupServices.search(
        this.state.entity.result.id
      ),
    });
  };

  handledContinue = async (fullName) => {
    this.setState({ fullName: fullName });
    this.searchCustomerApproval();
  };

  handledUpdated = async () => {
    await this.loadEntity();
    this.searchCustomerApproval();
  };

  render() {
    const {
      entity,
      items,
      fullName,
      loading,
      countWaitingForApproval,
      countApproved,
      countRejected,
    } = this.state;
    const dealerGroupId =
      entity && entity.isValid ? entity.result.dealerGroupId : '';
    return (
      <div>
        {entity && entity.isValid && <Menu dealerGroupId={dealerGroupId} />}
        {entity && !entity.isValid && <Menu dealerGroupId={dealerGroupId} />}
        {!loading && entity.isValid && entity.result.documents.length > 0 && (
          <div>
            <h3 className="text-center">DOCUMENT APPROVAL REQUEST</h3>
            <h5 className="text-center">
              AMI Attachments is requesting approval of documents for Order #
              {entity.result.workOrderNumber}, PO #{entity.result.poNumber}
            </h5>
            {countWaitingForApproval > 0 && (
              <h5 className="text-center">
                <span className="approval-document-count">
                  {countWaitingForApproval}
                </span>{' '}
                documents require approval
              </h5>
            )}
            {countApproved > 0 && (
              <h5 className="text-center">
                <span>{countApproved}</span> documents were approved{' '}
                <i className="fa fa-check-circle fa-lg text-success" />
              </h5>
            )}
            {countRejected > 0 && (
              <h5 className="text-center">
                <span>{countRejected}</span> documents were rejected{' '}
                <i className="fa fa-times-circle fa-lg text-danger" />
              </h5>
            )}
            {!loading && countWaitingForApproval > 0 && items.length === 0 && (
              <div className="row">
                <div className="col-sm-2"></div>
                <div className="card-deck col-sm-8">
                  <CustomerApprovalContactInfo
                    entity={entity.result}
                    onUpdated={this.handledContinue}
                  />
                </div>
                <div className="col-sm-2"></div>
              </div>
            )}
            {!loading && items.length > 0 && (
              <div className="container">
                <CustomerApprovalList
                  items={items}
                  fullName={fullName}
                  onUpdated={this.handledUpdated}
                />
              </div>
            )}
          </div>
        )}
        {!loading && entity.result.documents.length === 0 && (
          <CustomerApprovalWithoutDocuments
            id={
              entity.isValid
                ? entity.result.workOrderNumber
                : this.props.match.params.id
            }
            isValid={entity.isValid}
          />
        )}
        {loading && (
          <div className="container text-center">
            <h4 className="mt-5 mb-2">Loading</h4>
            <Spinner show={true} size="fa-5x" />
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(CustomerApprovalPage);
